import {action, observable} from 'mobx';
import {addMonths, setDate} from 'date-fns';

export default class {
  @observable nextPaymentDatetime;
  @observable last4 = '';
  @observable lastPaymentDay;
  @observable plaidAccountId = '';
  @observable plaidToken = '';

  @action setNextPaymentDatetimeFrom = (day) => {
    const currentDay = new Date().getDate();

    if(day < currentDay || (this.lastPaymentDay && this.lastPaymentDay <= currentDay)) {
      this.nextPaymentDatetime = setDate(addMonths(new Date(), 1), day);
    } else if(day >= currentDay) {
      this.nextPaymentDatetime = setDate(new Date(), day);
    }
  }
}
